import axiosInstance from "./axiosMedia"; // Update the path accordingly
import { useState } from "react";
const useFetchMedia = () => {
  const [loading, setLoading] = useState(false);

  const fetchMedia = async (url) => {
    setLoading(true);
    try {
      // Fetch data from the URL
      const response = await axiosInstance.get(url, { responseType: "blob" });

      // Extract content type from headers
      const contentType = response.headers["content-type"];
      // Create a URL for the blob data
      const mediaUrl = URL.createObjectURL(response.data);

      setLoading(false);
      return {
        mediaType: contentType.split("/")[0], // image, audio, or video
        url: mediaUrl,
      };
    } catch (error) {
      setLoading(false);
      throw error; // Rethrow the error to handle it in the component
    }
  };

  return { fetchMedia, loading };
};

export default useFetchMedia;
